<template>
  <v-autocomplete
    v-model="valueModel"
    :error-messages="errorMessages"
    :items="items"
    :loading="loading"
    :disabled="disabled"
    :hide-details="hideDetails"
    name="yacht_model_id"
    :label="label"
    :item-text="(model) => `${model.full_label} (${model.model_year})`"
    item-value="id"
    autocomplete="off"
    :outlined="outlined"
    :solo="solo"
    :clearable="clearable"
    :multiple="multiple"
    :return-object="returnObject"
    :dense="dense"
    :chips="chips"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar>
        <img
          v-if="item.main_image"
          :src="item.main_image.path"
        >
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.full_label }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <span class="grey--text">#{{ item.id }}</span> &middot;
          <strong>{{ item.model_year }}</strong> &middot;
          {{ item.cabin_count_description }} cabins &middot;
          {{ item.berth_count_description }} berths &middot;
          {{ item.engines_description }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'YachtModelSelect',
  props: {
    items: {
      type: Array,
      required: true
    },
    errorMessages: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: () => null
    },
    label: {
      type: String,
      default: 'Yacht Model'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    deletableChips: {
      type: Boolean,
      default: false
    },
    smallChips: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    valueModel: {
      set: function (value) {
        this.$emit('input', value)
      },
      get: function () {
        return this.value
      }
    }
  }
}
</script>

<style scoped>

</style>
